import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import FileDownloadIcon from 'components/material-symbol/icons/FileDownload'
import OpenInNewIcon from 'components/material-symbol/icons/OpenInNew'
import { useStyles } from './styles'
import { trackVirtualCoachingEvent, VIRTUAL_COACHING_EVENTS } from './analytics'
import DownloadVideoDialog from './download-video-dialog'
import { getDownloadUrl, isHttpsUrl, ONFORM_APP_URL } from './utils'

// Download and "Analyze in Onform" for one golfer video. `label` ("Video 2 of
// 3") is only set in the multi-video viewer, so the buttons stay
// distinguishable to screen readers. Download opens the download dialog on the
// page itself (`downloadInDialog`); inside the viewer it downloads the current
// video directly, so a dialog never opens on top of another dialog.
const SwingVideoActions = ({
  video,
  label,
  showAnalyze,
  downloadInDialog = false,
  trackedProps,
}) => {
  const classes = useStyles()
  const [downloadOpen, setDownloadOpen] = useState(false)
  return (
    <Box className={classes.mediaActions}>
      {isHttpsUrl(video.url) ? (
        <Button
          variant="outlined"
          color="primary"
          classes={{ label: classes.buttonLabel }}
          startIcon={<FileDownloadIcon aria-hidden />}
          aria-label={label ? `Download ${label}` : undefined}
          {...(downloadInDialog
            ? { onClick: () => setDownloadOpen(true) }
            : {
              component: 'a',
              href: getDownloadUrl(video.url),
              download: true,
              target: '_blank',
              rel: 'noopener noreferrer',
              onClick: () =>
                trackVirtualCoachingEvent(
                  VIRTUAL_COACHING_EVENTS.DOWNLOAD_CLICKED,
                  trackedProps,
                ),
            })}
        >
          Download
        </Button>
      ) : null}
      {showAnalyze ? (
        <Button
          variant="outlined"
          color="primary"
          component="a"
          href={ONFORM_APP_URL}
          target="_blank"
          rel="noopener noreferrer"
          classes={{ label: classes.buttonLabel }}
          startIcon={<OpenInNewIcon aria-hidden />}
          aria-label={label ? `Analyze ${label} in Onform` : undefined}
          onClick={() =>
            trackVirtualCoachingEvent(
              VIRTUAL_COACHING_EVENTS.ONFORM_CLICKED,
              trackedProps,
            )
          }
        >
          Analyze in Onform
        </Button>
      ) : null}
      {downloadInDialog ? (
        <DownloadVideoDialog
          open={downloadOpen}
          onClose={() => setDownloadOpen(false)}
          video={video}
          trackedProps={trackedProps}
        />
      ) : null}
    </Box>
  )
}

SwingVideoActions.propTypes = {
  video: PropTypes.shape({ url: PropTypes.string.isRequired }).isRequired,
  label: PropTypes.string,
  showAnalyze: PropTypes.bool,
  downloadInDialog: PropTypes.bool,
  trackedProps: PropTypes.object,
}

export default SwingVideoActions
